
import {
  asideDisplay,
  headerLeft,
  headerWidthFluid,
} from "@/core/helpers/config";
import KTTopbar from "@/layout/header/Topbar.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "KTHeader",
  props: {
    title: String,
  },
  components: {
    KTTopbar,
  },
  setup() {
    return {
      headerWidthFluid,
      headerLeft,
      asideDisplay,
    };
  },
});
